module.exports = __webpack_public_path__ + "img/03.69707cc9.jpg";